(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/middleware-authenticated/assets/authenticated.js') >= 0) return;  svs.modules.push('/components/payment/middleware-authenticated/assets/authenticated.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const MiddlewarePaymentError = svs.components.payment.common.error.MiddlewarePaymentError;
const _svs$core = svs.core,
  userSession = _svs$core.userSession,
  urlMapping = _svs$core.urlMapping;
const _userSession$roles = userSession.roles,
  PLAYER = _userSession$roles.PLAYER,
  RETAILER = _userSession$roles.RETAILER;
const convertParamsToObject = params => {
  const searchParams = {};
  for (const _ref of params.entries()) {
    var _ref2 = _slicedToArray(_ref, 2);
    const key = _ref2[0];
    const value = _ref2[1];
    searchParams[key] = value;
  }
  return searchParams;
};
const getReturnUrl = _ref3 => {
  let extraParams = _ref3.extraParams;
  const returnQuery = extraParams instanceof URLSearchParams ? convertParamsToObject(extraParams) : extraParams;
  const queryParams = Object.keys(returnQuery).reduce((acc, key, index) => {
    if (typeof returnQuery[key] !== 'undefined') {
      if (index === 0) {
        return "".concat(key, "=").concat(returnQuery[key]);
      }

      return "".concat(acc, "&").concat(key, "=").concat(returnQuery[key]);
    }
    return acc;
  }, '');
  return "".concat(window.location.pathname, "?").concat(encodeURIComponent(queryParams));
};
const authenticated = _ref4 => {
  let userContext = _ref4.userContext;
  return next => {
    try {
      if (!userSession.hasRole(PLAYER) && !userSession.hasRole(RETAILER)) {
        let returnUrl = window.location.href;
        if (userContext.returnQuery) {
          returnUrl = svs.components.payment.middleware.authenticated.getReturnUrl({
            extraParams: userContext.returnQuery
          });
        }
        const loginHome = urlMapping.get('loginHome');
        if (loginHome) {
          window.location.href = "".concat(loginHome, "?returnUrl=").concat(returnUrl);
        }
        return next(new MiddlewarePaymentError({
          clientCode: MiddlewarePaymentError.ErrorCodes.NOT_AUTHENTICATED
        }));
      }
    } catch (error) {
      return next(new MiddlewarePaymentError({
        clientCode: MiddlewarePaymentError.ErrorCodes.NOT_AUTHENTICATED
      }));
    }
    next();
  };
};
setGlobal('svs.components.payment.middleware.authenticated', {
  authenticated,
  getReturnUrl
});

 })(window);